import { Consultation } from "../../../../calendar/model";
import { DayProps } from "../Day";
import ToggleConsultation from "./ToggleConsultation";
import ConsultationInputs from "./ConsultationInputs";
import DaySelector from "./DaySelector";
import { DayRowContainer, DaySelectorPlaceholder } from "./StyledElements";
import React from "react";

export interface IndexedConsultation extends Consultation {
    index: number;
}

interface Props {
    additional?: boolean;
    consultation: IndexedConsultation;
    day: DayProps;
    empty?: boolean;
}

const DayRow = ({ additional, consultation, day }: Props) => (
    <DayRowContainer additional={!!additional} isRegular={day.isRegular}>
        {additional ? <DaySelectorPlaceholder /> : <DaySelector day={day} />}
        <ConsultationInputs consultation={consultation} day={day} />
        <ToggleConsultation
            toggleType={additional ? "remove" : "add"}
            day={day}
            consultationIndex={consultation.index}
            additional={!!additional}
        />
    </DayRowContainer>
);

export default React.memo(DayRow);
